import React, { Dispatch, ReactNode, SetStateAction } from "react";

interface IPortalContext {
    content?: {[key: string]: ReactNode | ReactNode[]},
    setContent: Dispatch<SetStateAction<undefined | {[key: string]: ReactNode | ReactNode[]}>>
}

export const PortalContentContext = React.createContext<IPortalContext>({
    setContent: () => {},
})
